

























import {Component, Prop, Vue} from 'vue-property-decorator';
import {TableHeader} from '@/model/CommonModel';
import LikeFilter from '@/components/table/filter/LikeFilter.vue';
import DateRangeFilter from '@/components/table/filter/DateRangeFilter.vue';
import NumericRangeFilter from '@/components/table/filter/NumericRangeFilter.vue';
import LikeCheckFilter from '@/components/table/filter/LikeCheckFilter.vue';
import CheckFilter from '@/components/table/filter/CheckFilter.vue';
import LikeAllFilter from '@/components/table/filter/LikeAllFilter.vue';
import DateTimeRangeFilter from '@/components/table/filter/DateTimeRangeFilter.vue';

@Component({
             components: {
               DateTimeRangeFilter,
               LikeAllFilter, CheckFilter, LikeCheckFilter, DateRangeFilter, NumericRangeFilter, LikeFilter
             }
           })
export default class FilterFacade extends Vue {
  @Prop({default: ''}) private menuId: string;
  @Prop() private tableHeader: TableHeader;

  get isLikeFilter() {
    return this.tableHeader.filterType === 'LIKE';
  }

  get isDateRangeFilter() {
    return this.tableHeader.filterType === 'BETWEEN_DATE';
  }

  get isNumericRangeFilter() {
    return this.tableHeader.filterType === 'BETWEEN_NUMERIC';
  }

  get isLikeCheckFilter() {
    return this.tableHeader.filterType === 'LIKE_CHECK';
  }

  get isCheckFilter() {
    return this.tableHeader.filterType === 'CHECK';
  }

  get isLikeAllFilter() {
    return this.tableHeader.filterType === 'LIKE_ALL';
  }

  get isDateTimeRangeFilter() {
    return this.tableHeader.filterType === 'BETWEEN_DATE_TIME';
  }

  get getMenuId() {
    return this.menuId;
  }

  get getTableHeader() {
    return this.tableHeader;
  }

  public onRefresh() {
    this.$emit('refresh');
  }
}
